import React from 'react';
import { useActiveCampaigns, useAuth } from 'api';
import { Text, CampaignCard, Loading, Header, Card, Button } from 'ui';
import { useParams, Redirect } from 'react-router-dom';
import "./index.css";
import Report from './Report';

export default function Campaigns(props) {
  const auth = useAuth();
  const campaigns = useActiveCampaigns(auth && auth.user.companyId);
  let { campaignId } = useParams();
  
  if(!campaigns) {
    return <Loading/>;
  }
  
  if(campaigns.length === 0) {
    return (
      <div className="reports-placeholder">
        <Header>
          <Text large light style={{flex:1}}>Campaign Analytics</Text>
        </Header>
        <div className="reports-placeholder-body">
          <Text huge block white>Track and Analyze Your Campaign Analytics</Text>
          <Text white block>
            Track campaign performance with our built-in analytics tools and reporting or connect your Google Analytics account.
          </Text>
          <Button to="/campaign/create" style={{backgroundColor:"white", marginBottom:40}}>
            <Text color="#243746">Start Your First Campaign</Text>
          </Button>
        </div>
      </div>
    );
  }
  
  if(!campaignId) {
    return <Redirect to={`/reports/${campaigns[0].id}`}/>;
  }
  
  // Render
  
  return (
    <div className="reports">
      <Header>
        <Text large light style={{flex:1}}>Campaign Analytics</Text>
      </Header>
      <div className="reports-wrapper">
        <div className="reports-campaigns">
          {campaigns.map(props => 
            <CampaignCard 
              to={props.id}
              key={props.id} 
              {...props}
              style={{
                opacity: campaignId === props.id ? 1 : 0.6
              }}
            />
          )}
        </div>
        <div className="reports-report">
          <Card>
            <Report campaignId={campaignId}/>
          </Card>
        </div>
      </div>
    </div>
  );
}